import axios from "axios";

const ENV_URL = process.env.REACT_APP_BACKEND_URL;

const envHost = (() => { try { return new URL(ENV_URL).hostname; } catch { return ""; } })();
const here = window.location.hostname;
const LOCAL = here === "localhost" || here === "127.0.0.1";

// Primary site (and local dev) talk to the configured backend. A white-label partner host
// (e.g. lulu.<partner-domain>) must call its own origin so the main brand never shows up.
export const isPrimaryHost = LOCAL || here === envHost || here === `www.${envHost}` || envHost === `www.${here}`;
export const API_ORIGIN = isPrimaryHost ? ENV_URL : window.location.origin;
const API = `${API_ORIGIN}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return e?.message || "Something went wrong";
}

export default api;
